// Might change to be more thorough in the validation later, e.g. restrict length or deduce country codes and patterns

const regexPattern = /^(\+?)(\d+)(?!\D)$/; // TODO Should one allow for spaces, and assume that they are trimmed later? (then update test data, as well)
export const phoneNoRegexPattern = '^(\\+?)(\\d+)(?!\\D)$'; // Only numbers and + is allowed
export const phoneNoRegexPatternNotRequired = `(${phoneNoRegexPattern})*`;

const validatePhoneNo = (phoneNo: string) => regexPattern.test(phoneNo);

export default validatePhoneNo;
